var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEssentials = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M17.186 15.289c0-2.517-1.635-4.557-3.65-4.557s-3.65 2.04-3.65 4.558v.504l-.002.029v6.089c0 .295.192.535.429.535h6.873v-7.158ZM28.787 12.672l2.554-.043M8.747 12.629h7.502M32.376 13.656c.621 0 1.124-.501 1.124-1.12 0-.618-.503-1.12-1.124-1.12-.62 0-1.124.502-1.124 1.12s.503 1.12 1.124 1.12ZM7.623 13.655c.62 0 1.123-.501 1.123-1.12 0-.618-.503-1.12-1.123-1.12s-1.123.502-1.123 1.12.503 1.12 1.123 1.12Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M29.45 15.29c0-2.517-1.635-4.558-3.65-4.558H13.536c2.016 0 3.65 2.04 3.65 4.558 0 .057-.004 2.823-.006 8.104a1 1 0 0 0-.012.12v6.452c0 .295.192.534.428.534h11.422c.236 0 .428-.24.428-.534l.004-14.676Z"
}))));
export default SvgEssentials;